<template>
    <div>
        <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>
        <!-- <h1><i class="text-black-50 fa fa-cogs" aria-hidden="true"></i> จัดการฟอร์ม</h1> -->
        <NavBar></NavBar>
        <div class="container">
            <table class="table table-hover" style="background-color: #fff;">
                <thead>
                    <tr>
                        <th v-for="(item, index) in thead" :key="index" scope="col" :class="item.class">{{ item.name }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tbody" :key="index">
                        <th scope="row">{{ index+1 }}</th>
                        <td>{{ item.pixel }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.userCreate }}</td>
                        <td>{{ item.updated_at }}</td>
                        <td class="text-right">
                            <button type="button" class="btn btn-light mr-2" title="ลบ" @click="validatedCancelFacebookPixel(item)"><i class="fa fa-trash fa-lg text-danger" aria-hidden="true"></i></button>
                        </td>
                    </tr>
                </tbody>

                <tbody :class="validated ? 'was-validated':''">
                    <tr v-for="(item, index) in listPixel" :key="index">
                        <th scope="row">{{ (tbody.length)+(index+1) }}</th>
                        <td>
                            <input type="text" :class="'form-control '+(validated ? 'was-validated':'')" placeholder="รหัสพิกเซล" v-model="item.pixel" required>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </td>
                        <td>
                            <input type="text" class="form-control" placeholder="รายละเอียด" v-model="item.description">
                        </td>
                        <td></td>
                        <td></td>
                        <td class="text-right">
                            <button type="button" class="btn btn-light mr-2" title="ยกเลิก" @click="removeRow(index)"><i class="fa fa-times-circle fa-lg text-danger" aria-hidden="true"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button type="button" class="btn btn-light pull-right" title="เพิ่มแถว" @click="addRow"><i class="fa fa-plus-circle fa-lg text-info" aria-hidden="true"></i> เพิ่มแถว</button>
            <button type="button" class="btn btn-light pull-right mr-2" title="บันทึก" @click="validatedSaveFacebookPixel"><i class="fa fa-floppy-o fa-lg text-success" aria-hidden="true"></i> บันทึก</button>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';

import NavBar from '@/components/NavBar';
export default {
    components:{
        NavBar
    },

    data(){
        return {
            user: null,
            show: false,
            validated: false,
            thead: [
                { name: '#' },
                { name: 'รหัสพิกเซล' },
                { name: 'รายละเอียด' },
                { name: 'ผู้สร้าง' },
                { name: 'วันที่แก้ไขล่าสุด' },
                { name: 'จัดการ', class: 'text-center' },
            ],
            tbody: [],
            listPixel: [{pixel: '', description: ''}],
            someDate: new Date()
        }
    },

    created(){
        this.user = this.$store.state.user;
        this.getFacebookPixelActiveAll();
    },

    watch: {

    },

    methods:{
        initialValue(){
            this.listPixel = [{pixel: '', description: ''}];
        },

        getFacebookPixelActiveAll(){
            this.show = true;
            Api.getFacebookPixelActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.tbody = data.result.map(it=> {
                        if(it.user_id==this.user.userId){
                            Vue.set(it, 'userCreate', 'ตัวเอง');
                        }else{
                            Vue.set(it, 'userCreate', it.user.name);
                        }

                        Vue.set(it, 'updated_at', this.$moment(it.updated_at).format('LLL'))
                        return it
                    })

                    this.initialValue();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        addRow(){
            var pixel = { pixel: '', description: '' };
            this.listPixel.push(pixel);
        },

        removeRow(number){
            this.listPixel = this.listPixel.filter((item,index)=>index!=number);
            if(!this.listPixel.length){
                this.addRow();
            }
        },

        validatedSaveFacebookPixel(){
            this.validated = true;
            var isEmpty = this.listPixel.find(it => it.pixel.trim()=='');
            if(isEmpty==undefined){
                this.validated = false;
                this.saveFacebookPixel();
            }else{
                this.$swal('กรุณากรอกข้อมูล!', '', "warning");
            }
        },

        saveFacebookPixel(){
            this.show = true;
            var token = this.user.token;
            var body = {
                listPixel: this.listPixel
            };
            Api.saveFacebookPixel(token,body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.getFacebookPixelActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        validatedCancelFacebookPixel(obj){
            this.$swal({
                title: 'ต้องการลบรหัสพิกเซล '+obj.pixel,
                text: "ตรวจสอบข้อมูลให้แน่ใจก่อนยืนยัน",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                if (result.isConfirmed) {
                    this.cancelFacebookPixel(obj);
                }
            })
        },

        cancelFacebookPixel(obj){
            this.show = true;
            var token = this.user.token;
            var body = {
                id: obj.id
            };
            Api.cancelFacebookPixel(token,body).then(res => {
                this.show = false;
                var {data} = res;
                console.log(data)
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.getFacebookPixelActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        }
    }
}
</script>

<style scoped>

</style>